// import { Injectable } from '@angular/core';
// import { ApiService } from '@app/core/services/api.service';
// import { Observable } from 'rxjs';
// import { UploadedFile } from '../interfaces/uploaded-file';

// @Injectable({
//   providedIn: 'root',
// })
// export class FilesService {
//   constructor(private apiService: ApiService) {}

// }

import { HttpEvent, HttpEventType, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/services/api.service';
import { UploadedFile } from '@app/entities/files/interfaces/uploaded-file';
import { ResponseSuccess } from '@app/interfaces/response-success';
import { filter, map, Observable } from 'rxjs';
import { UploadFileReqDto } from '../interfaces/upload-file.req.dto';
import { UploadedFileBase } from '../interfaces/uploaded-file-base';
// import { Photo } from '@capacitor/camera';

interface ExtAndMimeType {
  ext: string;
  mimeType: string;
}

@Injectable({
  providedIn: 'root',
})
export class FilesService {
  private loadedFiles: any = {};

  private allowedFileTypes: ExtAndMimeType[] = [
    {
      ext: 'jpg',
      mimeType: 'image/jpeg',
    },
    {
      ext: 'jpeg',
      mimeType: 'image/jpeg',
    },
    {
      ext: 'png',
      mimeType: 'image/png',
    },
  ];
  constructor(private apiService: ApiService) {}

  markAsLoaded(src: string): void {
    this.loadedFiles[src] = true;
  }

  isLoaded(src: string): boolean {
    return !!this.loadedFiles[src];
  }

  getAllowedFileExtensionsForInputAcceptParameter(): string {
    return this.allowedFileTypes
      .map((value: ExtAndMimeType) => {
        return '.' + value.ext;
      })
      .join(',');
  }

  upload(
    file: string,
    name: string,
  ): Observable<ResponseSuccess<UploadedFile> | number> {
    return this.apiService
      .upload<ResponseSuccess<UploadedFile>>('file', {
        file,
        name,
      })
      .pipe(
        filter((event: HttpEvent<ResponseSuccess<UploadedFile>>) => {
          return (
            event.type === HttpEventType.UploadProgress ||
            event.type === HttpEventType.Response
          );
        }),
        map((event: HttpEvent<ResponseSuccess<UploadedFile>>) => {
          if (event.type === HttpEventType.UploadProgress) {
            return Math.floor((event.loaded / event.total!) * 100);
          }

          return (event as HttpResponse<ResponseSuccess<UploadedFile>>)
            .body as ResponseSuccess<UploadedFile>;
        }),
      );
  }

  uploadFile(data: UploadFileReqDto): Observable<UploadedFileBase> {
    return this.apiService.post<UploadedFileBase>('file/upload', data);
  }

  uploadAvatar(content: string, ext: string): any {
    return this.apiService.post<UploadedFile>('upload-avatar', {
      content,
      ext,
    });
  }

  isValidFileSize(file: File): boolean {
    const maxFileSize = 7 * 1024 * 1024; // 7 mb
    return file.size <= maxFileSize;
  }

  isValidFileType(file: File): boolean {
    // Validate mime type and extension
    const extension = this.getFileExtension(file.name);

    return (
      !!extension &&
      !!this.allowedFileTypes.find((item: ExtAndMimeType) => {
        return item.ext === extension && item.mimeType === file.type;
      })
    );
  }

  getFileExtension(fileName: string): string | undefined {
    return fileName.toLowerCase().split('.').pop();
  }

  imageToFile(image: any) {
    // imageToFile(image: Photo) {
    // Extract the base64 data from the dataUrl
    const base64String = image.dataUrl!.split(',')[1];

    // Decode the base64 string into binary data
    const binaryString = atob(base64String);

    // Convert binary string into a byte array
    const byteArray = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      byteArray[i] = binaryString.charCodeAt(i);
    }

    // Create a Blob from the byte array
    const blob = new Blob([byteArray], { type: `image/${image.format}` });

    // Create a File from the Blob
    const file = new File([blob], `photo.${image.format}`, {
      type: `image/${image.format}`,
    });

    return file;
  }
}
